var render = function render(_c,_vm){return _c('div',[_vm._m(0),_c('div',{staticClass:"d-flex w-100 justify-content-center mb-3"},[_c('b-spinner',{attrs:{"small":"","type":"grow"}}),_c('b-spinner',{attrs:{"small":"","type":"grow"}}),_c('b-spinner',{attrs:{"small":"","type":"grow"}})],1)])
}
var staticRenderFns = [function (_c,_vm){return _c('div',{staticClass:"d-flex w-100 justify-content-center"},[_c('strong',[_vm._v("Loading...")])])
}]

export { render, staticRenderFns }